import Swal from "sweetalert2";
import router from "@/router";
import 'animate.css';


function Done(message, push) {

    const Toast = Swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        background: '#38485f',
        color: '#ffffff',
        customClass: "font-5",
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        },
        hideClass: {
            popup: `
      animate__animated
      animate__fadeOutUp
      animate__faster
    `
        }
    });
    Toast.fire({
        icon: "success",
        title: message
    }).then(() => {
        if (push == 'back') {
            window.history.back()
        } else {
            router.push({name: push})
        }
    })

}

function Fault(message, push) {

    const Toast = Swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        background: '#38485f',
        color: '#ffffff',
        customClass: "font-5",
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        },
        hideClass: {
            popup: `
      animate__animated
      animate__fadeOutUp
      animate__faster
    `
        }
    });
    Toast.fire({
        icon: "error",
        title: message
    }).then(() => {
        if (push == 'back') {
            window.history.back()
        } else {
            router.push({name: push})
        }
    })

}

function Warning(message, push) {

    const Toast = Swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        background: '#38485f',
        color: '#ffffff',
        customClass: "font-5",
        didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
        },
        hideClass: {
            popup: `
      animate__animated
      animate__fadeOutUp
      animate__faster
    `
        }
    });
    Toast.fire({
        icon: "warning",
        title: message
    }).then(() => {
        if (push == 'back') {
            window.history.back()
        } else {
            router.push({name: push})
        }
    })

}

function Catch(res, func, click) {

    let x = true
    if (click) x = false

    if (res.message == 'Network Error') {
        Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            confirmButtonColor: '#2F3A96',
            text: '!از اتصال تلفن خود به اینترنت اطمینان حاصل فرمایید',
            allowOutsideClick: x
        }).then((result) => {
            if (result.isConfirmed) {
                func()
            }
        })
    } else {
        Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            confirmButtonColor: '#2F3A96',
            text: 'خطای ارتباط با سرور!',
        }).then((result) => {
            if (result.isConfirmed) {
                func()
            }
        })
    }

}

async function Orders() {

    let x = await Swal.fire({
        text: 'کاربر عزیز شما یک سبد خرید فعال دارید. خرید همزمان از دو فروشگاه مقدور نمی باشد!',
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: 'لغو',
        cancelButtonColor: '#FF3C00',
        confirmButtonColor: '#2F3A96',
        confirmButtonText: 'ساخت سبد خرید جدید'
    })

    if (x.isConfirmed) {

        let res = await Swal.fire({
            text: 'با ساختن سبد خرید جدید سبد خرید قبلی شما حذف خواهد شد!',
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: 'لغو',
            cancelButtonColor: '#FF3C00',
            confirmButtonColor: '#2F3A96',
            confirmButtonText: 'ادامه دادن',
        })
        return res
    }

return x


}

async function Question(message , confirm) {

    return await Swal.fire({
    text: message,
    icon: "question",
    showCancelButton: true,
    cancelButtonText: 'انصراف',
    cancelButtonColor: '#FF3C00',
    confirmButtonColor: '#2F3A96',
    confirmButtonText: confirm
})

}

async function Updating() {
    await Swal.fire({
        icon: 'warning',
        confirmButtonText: 'متوجه شدم',
        confirmButtonColor: '#2F3A96',
        text: 'اپلیکیشن درحال آپدیت می باشد لطفا دقایقی دیگر مجددا وارد شوید!',
        allowOutsideClick: false,
    }).then((res)=>{
        if (res.isConfirmed){
            console.log('sss')
        }
    })
}

async function NewVersion() {

    await Swal.fire({
        icon: 'warning',
        confirmButtonText: 'دانلود نسخه جدید',
        confirmButtonColor: '#2F3A96',
        text: 'برای استفاده از اپلیکیشن لطفا از آخرین نسخه استفاده کنید!',
        allowOutsideClick: false,
    }).then((res)=>{
        if (res.isConfirmed){
            window.location.href = 'https://market-app.ir'
        }
    })
}

async function Dialog(title , message , confirm , cancel , icon , colorConfirm , colorCancel) {

    let options = {
        cancelButtonColor: colorCancel ? colorCancel : '#FF3C00',
        confirmButtonColor: colorConfirm ? colorConfirm : '#2F3A96',
    }

    if (title) options.title = title
    if (message) options.text = message
    if (confirm) options.confirmButtonText = confirm
    if (cancel){
        options.showCancelButton = true
        options.cancelButtonText = cancel
    }
    if (icon) options.icon = icon

    return await Swal.fire(options)
}


export default {Done, Fault, Catch, Warning, Orders , Question , Updating , NewVersion , Dialog}